/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Index Value component for impact evaluation
Author: Deimos Space UK

Version: 1.0
*/
import React ,{useState, useEffect} from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import Spinner from 'react-bootstrap/Spinner';

export default function IndexValue({ data, loading }) {   
  const [stadisticsData, setStadisticsData] = useState([])

  useEffect(() => {
    if(data && data.index_breakdown){
      const index = []
     for (const key in data.index_breakdown) {
     if(data.index_breakdown[key]){
      index.push({
        name:formatKeys(key),
        data: data.index_breakdown[key].toExponential(2)
      })}
     }
     setStadisticsData(index)
    }
  }, [data]);

const formatKeys = (key) => {
  const keyName = key.charAt(0).toUpperCase() + key.slice(1);
  // chang _ for space
  if(keyName.includes('_')){
    return keyName.replace('_', ' ')
  }
  return keyName
}


  return (
    <Card className="widget-flat ">
      <CardBody>
        <i
          className="uil uil-signal-alt-3 float-right"
          style={{ fontSize: "2rem", color: '#003247' }}
        ></i>
        <h6 className="text-uppercase mt-0">DEBRIS INDEX VALUE</h6>
        
        {loading && <Spinner animation="border" />}
        {!loading &&
          <>
            <Row style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 20 }}>
            {
              setStadisticsData && stadisticsData?.map((item) => {
                return (
                  <Col xs={4} style={{ width: '50%' }}>
                    <h3 className="my-2 " id="active-users-count">{item?.data}</h3>
                    <p className="mb-0 text-muted">
                      <span className="text-nowrap">{item?.name}</span>
                    </p>
                  </Col>
                )
              })
            }
            </Row>
          </>
        }

      </CardBody>
    </Card>
  );
}
